import React, { useState, useEffect } from "react";
import moment from "moment";
import S3 from "aws-sdk/clients/s3";
import AWS from "aws-sdk/global";
import $ from "jquery";
import { NavLink } from "react-router-dom";
import BackButton from "./BackButton";

const Upload = (props) => {
  const [tab, setTab] = useState();
  const [lat, setLat] = useState();
  const [long, setLong] = useState();
  const [location_status, setLocation_status] = useState("success");
  const [description, setDescription] = useState("");
  const [benName, setBenName] = useState("");

  let i = 0;

  const queryString = window.location.search;

  const bucketname = "js-sdk-bucket";
  AWS.config.region = "ap-south-1"; // Region
  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: "ap-south-1:84027705-475d-4ca1-bac8-b2eb7407ae9f",
  });
  const bucket = new AWS.S3({
    params: {
      Bucket: bucketname,
    },
  });
  const alias_url = "https://campaign-images.narendramodi.in/";

  const [imageArry, setImageArry] = useState([]);
  const [filAry, setFileAry] = useState([]);
  var desc = React.useRef();
  var beneficiary = React.useRef();

  let imagesArray = [];

  const readFile = (e) => {
    // var ref = this;
    e.persist();

    let files = e.target.files;

    const queryString = window.location.search;

    if (queryString && queryString.indexOf("android") > -1) {
      $(".addmore").text("Add More");
      if (imageArry && imageArry.length > 0) {
        if (imageArry.length > 6) {
          $(".error_p_image").text("Please select upto 6 images only.");
          return false;
        }
      }
    } else {
      if (files && files.length > 0) {
        if (files.length > 6) {
          $(".error_p_image").text("Please select upto 6 images only.");
          return false;
        }
      }
    }

    $(".error_p_image").text("");

    let imageArrTemp = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      let extension = file.type.split("/");
      extension = extension[extension.length - 1];
      if (
        file.type != "image/jpeg" &&
        file.type != "image/png" &&
        file.type != "image/jpg"
      ) {
        $(".error_p_image").text("Please select images only.");
        // allphotos = ''
        return false;
      } else {
        $(".error_p_image").text("");
      }
      imageArrTemp.push(file);
    }

    let Ary = [...imageArry, ...imageArrTemp];
    if (queryString && queryString.indexOf("android") > -1) {
      $(".addmore").text("Add More");
      if (Ary && Ary.length > 0) {
        if (Ary.length > 6) {
          $(".error_p_image").text("Please select upto 6 images only.");
          return false;
        }
      }
    } else {
      if (Ary && Ary.length > 0) {
        if (Ary.length > 6) {
          $(".error_p_image").text("Please select upto 6 images only.");
          return false;
        }
      }
    }

    setImageArry([...imageArry, ...imageArrTemp]);
    return false;
  };

  const nextsubmit = () => {
    // let msg = desc.current.value;
    let msg = description;
    // let beni = beneficiary.current.value;
    let beni = benName;
    let latval = lat && lat.toString();
    let longval = long && long.toString();
    let imagelength = imageArry.length;

    let isMla = localStorage.getItem("user");
    let state_id =
      isMla && JSON.parse(isMla)["state_id"]
        ? JSON.parse(isMla)["state_id"]
        : 0;
    let constituency_id =
      isMla && JSON.parse(isMla)["user_constituency"]
        ? JSON.parse(isMla)["user_constituency"]
        : 0;
    let state_name =
      isMla && JSON.parse(isMla)["state_name"]
        ? JSON.parse(isMla)["state_name"]
        : "";
    let constituency_name =
      isMla && JSON.parse(isMla)["constituency_name"]
        ? JSON.parse(isMla)["constituency_name"]
        : "";

    if (imageArry && imageArry.length == 0) {
      $(".error_p_image").text("Please select images.");
      return false;
    }
    $(".error_p_image").text("");

    if (msg && msg.length > 100) {
      $(".error_p_msg").text("Description length must be less than 100 chars.");
      return false;
    } else {
      $(".error_p_msg").text("");
    }

    if (beni && beni.length > 50) {
      $(".error_p_msg_beni").text(
        "Beneficiary Name must be less than 50 chars."
      );
      return false;
    } else {
      $(".error_p_msg_beni").text("");
    }

    let ImageArray = [];
    let post_id = Date.now();

    let dataObj = {
      description: msg ? msg : "",
      beneficiary: beni ? beni : "",
      lat: latval,
      long: longval,
      post_id: post_id,
      state_id: state_id,
      constituency_id: constituency_id,
      state_name: state_name,
      constituency_name: constituency_name,
      images_count: imagelength,
    };

    for (let i = 0; i < imageArry.length; i++) {
      if (
        imageArry[i].type != "image/jpeg" &&
        imageArry[i].type != "image/png" &&
        imageArry[i].type != "image/jpg"
      ) {
        $(".error_p_image").text("You can upload images only.");
        $(".loader_bg").hide();
        break;
      }
      const el = imageArry[i];
      let extension = el.type.split("/");
      extension = extension[extension.length - 1];
      var sessionid2 = Date.now();
      let newDate = new Date();
      let month = newDate.getMonth();
      let date = newDate.getDate();
      var video2Key = `celebrating_benificiary/2023/${
        month + 1
      }/${date}/photo_${sessionid2}_${i}.${extension}`;
      // var video2Key = `manu/photo_${sessionid2}_${i}.${extension}`;
      uploadToS3(
        el,
        video2Key,
        null,
        "",
        post_id,
        state_name,
        constituency_name,
        i,
        imageArry,
        dataObj
      );
      ImageArray.push(alias_url + video2Key);
    }
    // let dataObj = {
    //   images: JSON.stringify(ImageArray),
    //   description: msg ? msg : "",
    //   beneficiary: beni ? beni : "",
    //   lat: latval,
    //   long: longval,
    //   post_id: post_id,
    //   state_id: state_id,
    //   constituency_id: constituency_id,
    //   state_name: state_name,
    //   constituency_name: constituency_name,
    //   images_count: imagelength
    // };
    // console.log("vbvbvbv", dataObj);

    // props.getData(dataObj);
    // props.nextpage("checkin");
  };

  const uploadToS3 = (
    file,
    fileKey,
    callback,
    mode = "photo",
    post_id,
    statename,
    constituencyname,
    index,
    arr,
    dataObj
  ) => {
    $(".loader_bg").show();
    var sessionid = Date.now();
    var Image_id = fileKey;
    let newDate = new Date();
    let month = newDate.getMonth();
    let date = newDate.getDate();
    var originalKey = fileKey
      ? fileKey
      : `celebrating_benificiary/2023/${
          month + 1
        }/${date}/${mode}/${mode}_${sessionid}.jpg`;
    // var originalKey = fileKey ? fileKey : `manu/${mode}/${mode}_${sessionid}.jpg`;
    var params = {
      Key: originalKey,
      ContentType: file.type ? file.type : "image/jpeg",
      Body: file,
      Metadata: {
        image_id: Image_id.toString(),
        post_id: post_id.toString(),
        state_name: statename,
        constituency_name: constituencyname
          ? constituencyname.split("–").join(" ")
          : "",
      },
      ACL: "public-read",
    };
    imagesArray.push(alias_url + fileKey);
    if (!callback) {
      callback = (err, data) => {
        console.log("uploaded data......", data);
        if (i++ == imageArry.length - 1) {
          console.log("last iamge arr");
          let ob = { ...dataObj };
          ob["images"] = JSON.stringify(imagesArray);
          console.log("object ob is", ob);
          props.getData(ob);
          props.nextpage("checkin");
          $(".loader_bg").hide();
        }
      };
    }
    console.log("params", params);
    bucket.putObject(params, callback);
  };
  console.log("len", imageArry.length);
  return (
    <>
      <div className="smajik_bg">
        <div className="container">
          <BackButton
            close={props.close ? props.close : props.nextpage("gallery")}
          />
          <div className="smajik_banner">
            <img src="/assets/images/img-31.jpg" alt="" />
          </div>

          <div className="smajik_list">
            {/* <ul>
              <li className={tab == "popular" ? "active" : ""}>
                <NavLink to={"/" + queryString}>popular </NavLink>
              </li>
              <li className={tab == "gallery" ? "active" : ""}>
                <NavLink to={"/gallery" + queryString}>recent </NavLink>
              </li>
            </ul> */}
          </div>
        </div>
      </div>
      <div className="upload_bg">
        <div className="container">
          <div className="upload_main">
            <div className="upload_div">
              <input
                type="file"
                accept="image/png, image/jpeg, image/jpg"
                multiple
                onChange={(e) => {
                  readFile(e);
                }}
              />
              <h4>
                <img src="/assets/images/upload.svg" alt="" />{" "}
                <span className="addmore">Upload Pictures</span>
              </h4>
            </div>
            <h6>Up to 6 images</h6>
            {imageArry && imageArry.length > 0 && <h6>{imageArry.length}/6</h6>}
            <p className="error_p error_p_image"></p>
          </div>

          <div className="desc_detail">
            <h5>Description</h5>
            <textarea
              // ref={desc}
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
                if (e.target.value.length < 101) {
                  $(".error_p_msg").text("");
                } else {
                  $(".error_p_msg").text(
                    "Description length must be less than 100 chars."
                  );
                }
              }}
              placeholder="Describe your memorable experience with the beneficiary..."
              maxLength={100}
            />
            <p className="error_p error_p_msg"></p>
          </div>

          <div className="desc_detail">
            <h5>Beneficiary Name</h5>
            <input
              // ref={beneficiary}
              value={benName}
              onChange={(e) => {
                setBenName(e.target.value);
                if (e.target.value.length < 51) {
                  $(".error_p_msg_beni").text("");
                } else {
                  $(".error_p_msg_beni").text(
                    "Beneficiary name must be less than 50 chars."
                  );
                }
              }}
              type="text"
              placeholder="Beneficiary Name"
              maxLength={50}
            />
            <p className="error_p error_p_msg_beni"></p>
          </div>
          <div className="next_btn">
            <a
              href="#"
              onClick={() => {
                nextsubmit();
              }}
            >
              Next
            </a>
          </div>

          {/* {finalbutton && (
                        <div className="next_btn">
                        <a href="#" onClick={() => { submit(); }}>Submit</a>
                    </div>
                    )}
                     */}
        </div>
      </div>
    </>
  );
};

export default Upload;
